module.exports = __webpack_public_path__ + "assets/img/warrior-name-c4fe6bf9.png";